import { render, staticRenderFns } from "./Genreview.vue?vue&type=template&id=d3406da8&scoped=true"
import script from "./Genreview.vue?vue&type=script&lang=js"
export * from "./Genreview.vue?vue&type=script&lang=js"
import style0 from "./Genreview.vue?vue&type=style&index=0&id=d3406da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3406da8",
  null
  
)

export default component.exports